import { installCrashDiagnostics, renderStartupFallback, reportBootError, shouldUseSafeLanding } from "./lib/crash-diagnostics";
import { exposeRuntimeHealthChecks, renderSafeLanding } from "./lib/runtime-health";

// Keep this entrypoint intentionally tiny. Diagnostics must install before the
// heavier app/i18n/CSS modules are imported so module-load failures cannot leave
// a blank screen.
installCrashDiagnostics();
exposeRuntimeHealthChecks();

Promise.resolve().then(() => {
  if (shouldUseSafeLanding()) {
    renderSafeLanding("bundle-rollback");
    return;
  }
  return import("./bootstrap").then(() => {
    // Bundle loaded successfully — clear any stale rollback flag from a
    // previous failed boot so the user is never permanently trapped in safe mode.
    try { localStorage.removeItem("bantoo_bundle_rollback"); } catch { /* noop */ }
  });
}).catch((error) => {
  reportBootError("bootstrap-import", error);
  // Do NOT persist the rollback flag here — that previously trapped users in
  // safe-landing forever. Show the fallback for THIS load only; next refresh
  // retries the real bundle.
  renderStartupFallback("bootstrap-import", error);
});
